import Button from "shared/Button";
import backImg from "../../assets/images/back.svg";
import { useNavigate } from "react-router-dom";
import AddTeamForm from "./ui/AddTeamForm";
import { useEffect } from "react";
import { useTeams } from "./modal/teamsContext";
import { useParams } from "react-router-dom";

const UpdateTeam = () => {
  const { teamList, editTeamData, editingTeam } = useTeams();

  const { teamId } = useParams();
  console.log(teamId, "ID");
  const navigate = useNavigate();

  const backPgae = () => {
    navigate(-1);
  };

  useEffect(() => {
    if (teamList.length > 0 && editingTeam === null) {
      const foundTeam = teamList.find(
        (team) => team?.teamId === parseInt(teamId || "")
      );
      console.log(foundTeam, "Found");
      if (foundTeam) {
        editTeamData(foundTeam);
      }
    }
    return;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [teamList, teamId]);
  return (
    <>
      <Button disableDefaultStyles type="button" onClick={backPgae} buttonClasses="mt-5 w-5 h-5 md:w-7 md:h-7">
        <img src={backImg} alt="back" />
      </Button>
      <h2 className="mt-5 md:mt-[46px] text-2xl md:text-3xl lg:text-[58px] text-center font-semibold font-poppins lg:leading-[140%] text-foreground">
        Update the Team
      </h2>
      <AddTeamForm />
    </>
  );
};

export default UpdateTeam;
